import { type FC } from 'react'
import { RichText } from '~/components/RichText/RichText'
import { type GenericContentProps } from './GenericContent.interface'

export const GenericContent: FC<GenericContentProps> = ({ title, introText, bodyText }) => (
  <div>
    <h1 className="title-sm">{title}</h1>
    { introText && <RichText className="intro" richtext={introText} /> }
    { bodyText && <RichText richtext={bodyText} /> }
  </div>
)
